export const formatName = (name: string) => name.split(' ')[0]
